export default {
  线索商户: "ร้านค้าที่สนใจ",
  商户ID: "รหัสร้านค้าของผู้ขาย",
  入驻邮箱: "อีเมลสำหรับลงทะเบียน",
  联系电话: "เบอร์โทร",
  授权店铺: "ร้านค้าที่ได้รับอนุญาต",
  报名商品数: "จำนวนสินค้าที่เข้าร่วม",
  TAP合作店铺: "ร้านค้าที่เข้าร่วม TAP",
  TAP合作商品数: "จำนวนสินค้าที่เข้าร่วม TAP",
  TAP申样数: "จำนวนการขอสินค้าตัวอย่าง TAP",
  来源: "ช่องทาง",
  跟进: "ติดตามสถานะ",
  自主入驻: "ลงทะเบียนด้วยตนเอง",
  跟进商户: "ติดตามร้านค้า",
  跟进人: "ผู้ดูแล",
  供应链名称: "ชื่อซัพพลายเชน",
  "该店铺已绑定其他供应链，不可重复绑定！": "ร้านค้ามีการลงทะเบียนเรียบร้อยแล้ว ไม่สามารถลงซ้ำได้",
  供应链ID: "รหัสซัพพลายเชน",
  跟进联系方式: "ข้อมูลการติดต่อ",
  联系邮箱: "อีเมล",
  "Youpik Grow联系电话": "เบอร์ติดต่อ Youpik Grow",
  店铺名称: "ชื่อร้านค้า",
  店铺号: "รหัสร้านค้า",
  是: "ใช่",
  否: "ไม่ใช่",
  店铺商品数: "จำนวนสินค้าในร้าน",
  店铺GMV: "ยอดขายรวมของร้าน",
  店铺销量: "จำนวนยอดขาย",
  店铺总订单: "คำสั่งซื้อทั้งหมด",
  SKU订单: "ยอดสั่งซื้อ (SKU)",
  订单均价: "ราคาเฉลี่ยต่อคำสั่งซื้อ",
  "该店铺已授权至供应链，不可操作更改！": "该ร้านค้ามีการลงทะเบียนเรียบร้อยแล้ว ไม่สามารถลงซ้ำได้",
  入驻状态: "สถานะการเข้าร่วม",
  未入驻: "ยังไม่เข้าร่วม",
  已入驻: "เข้าร่วมแล้ว",
  复制入驻链接: "คัดลอกลิงก์เชิญ",
  该商户已入驻: "ร้านค้านี้เข้าร่วมแล้ว",
  "Youpik Grow账号详情": "รายละเอียดบัญชี Youpik Grow",
  查看: "ดูรายละเอียด",
  入驻时间: "เวลาที่เข้าร่วม",
  申样等待处理: "สินค้าตัวอย่างรอดำเนินการ",
  未处理样品申请: "คำขอตัวอย่างสินค้าที่รอดำเนินการ",
  超过24hr未处理: "เกิน 24 ชั่วโมงแล้วยังไม่ได้ดำเนินการ",
  最后一次申样日期: "วันที่ขอตัวอย่างสินค้าครั้งล่าสุด",
  发货链接: "ลิงก์สำหรับจัดส่งสินค้า",
  跟进时间: "เวลาติดตาม",
  查看发货详情: "ดูรายละเอียดการจัดส่ง",
  复制发货链接: "ดูรายละเอียดการจัดส่ง",
  编辑: "แก้ไข",
  商家TAP活动配置: "ร้านค้าตั้งค่าการเข้าร่วม TAP",
  活动ID: "รหัสกิจกรรม",
  活动名称: "ชื่อกิจกรรม",
  活动状态: "สถานะกิจกรรม",
  进行中: "กำลังดำเนินการ",
  邀约中: "อยู่ระหว่างการเชิญ",
  待邀约: "รอคำเชิญ",
  不可邀约: "ไม่สามารถเชิญได้",
  已结束: "สำเร็จ",
  报名时间: "เวลาที่เข้าร่วม",
  活动时间: "ระยะเวลากิจกรรม",
  邀约状态: "สถานะคำเชิญ",
  "进行中的联盟营销活动会在Youpik Grow公开展示给所有商家。": "กิจกรรมที่กำลังดำเนินการอยู่จะแสดงใน Youpik Grow",
  "活动进行中，还未展示给商家。": "ยังไม่สามารถแจ้งกิจกรรมได้",
  "活动结束，无法展示给商家": "กิจกรรมสิ้นสุดแล้ว",
  佣金要求: "เงื่อนไขคอมมิชชั่น",
  公开佣金: "คอมมิชชั่นทั่วไป",
  Youpik佣金: "คอมมิชชั่น Youpik",
  达人附加佣金: "คอมมิชชั่นพิเศษเพิ่มเติมสำหรับครีเอเตอร์",
  "商家在TikTok公开给达人的佣金%": "เปอร์เซ็นต์ค่าคอมมิชชั่นที่ร้านค้าเปิดเผยให้กับครีเอเตอร์บน TikTok",
  "与Youpik合作，商家支付给Youpik的营销佣金。": "ค่าคอมมิชชั่นการตลาดที่ร้านค้าต้องจ่ายให้กับ Youpik เมื่อร่วมมือกัน",
  "在公开佣金之上，商家需支付给达人的额外佣金加成%": "เปอร์เซ็นต์ค่าคอมมิชชั่นเพิ่มเติมที่ร้านค้าต้องจ่ายให้กับครีเอเตอร์นอกเหนือจากค่าคอมมิชชั่นปกติ",
  寄样要求: "เงื่อนไขการส่งสินค้าตัวอย่าง",
  必须: "จำเป็น",
  非必须: "ตัวเลือกเพิ่มเติม",
  编辑要求: "แก้ไขข้อกำหนด",
  暂停邀约: "ยกเลิกการเชิญ ",
  "在Youpik Grow商家后台暂停邀约该活动": "ยกเลิกการเชิญใน Youpik Grow",
  "Youpik Grow商家后台将不再展示该活动，你还要继续吗？": "<span style='color: red'>กิจกรรมนี้จะหยุดแสดงบน Youpik Grow</span> คุณต้องการดำเนินการต่อหรือไม่?",
  请设置该活动报名需满足的要求: "กรุณากำหนดเงื่อนไขการสมัคร",
  加入邀约: "เพิ่มในคำเชิญ",
  注册来源: "ช่องทางการสมัคร",
  注册邮箱: "อีเมลที่ใช้ลงทะเบียน",
  是否合作TAP: "เข้าร่วม TAP หรือไม่",
  全部: "ทั้งหมด",
  待发布: "รอเผยแพร่",
  即将开始: "กำลังจะเริ่ม",
  "仅商家运营可操作！": "เฉพาะเจ้าหน้าที่ดูแลร้านค้าเท่านั้น",
  佣金范围错误: "ช่วงค่าคอมมิชชั่นไม่ถูกต้อง",
  商家BD邀请: "การเชิญจากBDของร้านค้า",
  "复制成功，请勿将链接发送给错误商家！": "คัดลอกเรียบร้อยแล้ว กรุณาอย่าส่งลิงก์ให้กับร้านค้าที่ไม่ถูกต้อง!",
};
